import { Analytics } from '@src/config'
import { CheckoutOption } from '@src/types'

export const trackSubscription = ({
  subscriptionTotal,
  subscriptionId,
  onboarding,
  primaryProductId,
  nickname,
  checkoutOptions,
  trial,
}: {
  subscriptionTotal: number
  subscriptionId: string
  onboarding: boolean
  primaryProductId: string
  nickname: string
  checkoutOptions?: CheckoutOption[]
  trial?: boolean
}) => {
  Analytics.trackPurchase({
    revenue: subscriptionTotal,
    nickname,
    onboarding,
    transactionId: subscriptionId,
    productId: primaryProductId,
    checkoutOptionKinds: checkoutOptions?.map((option) => option.kind),
    trial,
  })
}
